
/* styles */
require("!!../../../../../node_modules/_extract-text-webpack-plugin@1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/style-rewriter?id=data-v-494fa7f0&scoped=true!less-loader?sourceMap!../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=styles&index=0!./detail-info.vue")

var Component = require("!../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./detail-info.vue"),
  /* template */
  require("!!../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-494fa7f0!../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./detail-info.vue"),
  /* scopeId */
  "data-v-494fa7f0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/backEndStage/person/bu/detail-info.vue
// module id = 623
// module chunks = 1